import classname from 'classnames/bind'
import { constants, Text } from '@adc/ui-adc'
import styles from './styles.scss'

const cx = classname.bind(styles)
const { ColorNames } = constants
interface ResultData {
  title: string | JSX.Element
  description: string | JSX.Element
  color: string
}
const ResultStats = () => {
  const resultsData: ResultData[] = [
    {
      title: <>100K+</>,
      description: (
        <>
          Active buyers <br />
          nationwide
        </>
      ),
      color: ColorNames.Info,
    },
    {
      title: <>80%</>,
      description: (
        <>
          Sellers receive offers <br />
          within 48 hours
        </>
      ),

      color: ColorNames.AdcDarkGreen,
    },
    {
      title: <>93%</>,
      description: (
        <>
          Listings attract interest <br />
          before foreclosure
        </>
      ),

      color: ColorNames.AdcLightBlue,
    },
  ]

  return (
    <div
      className={cx('main-claiming-process-container')}
      style={{ padding: '12px 0px', gap: '10px' }}
    >
      <div className={cx('header-section')}>
        <Text
          color={ColorNames.Info}
          size='massive'
          style={{ lineHeight: '36px' }}
          weight='heavy'
          as={'h1'}
        >
          Results That Speak for Themselves
        </Text>
      </div>

      <div className='divider'></div>

      <div className={cx('claim-container')}>
        {resultsData.map((results, index) => (
          <div className={cx('claim-column')} key={index}>
            <div className={cx('text-content')}>
              <Text
                style={{
                  fontSize: '64px',
                }}
                className={cx('text-title')}
                weight='black'
                as={'h3'}
                color={results.color}
              >
                {results.title}
              </Text>
              <Text
                className={cx('text-description')}
                color={ColorNames.Gray}
                size='big'
                weight='heavy'
                style={{ lineHeight: '26px' }}
              >
                {results.description}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ResultStats
